import PropTypes from 'prop-types';


export const QUOTA_THRESHOLDS = [
    {
        className: 'high',
        threshold: 75
    },
    {
        className: 'medium',
        threshold: 50
    },
    {
        className: 'low',
        threshold: 1
    }
];


// ------ shapes
export const SHAPE_KEYWORD_MATCH_QUOTA = {
    keyword: PropTypes.string.isRequired,
    quota: PropTypes.number.isRequired
};
